export default function uniqId () {
  if (!window._uniqIdCounter) {
    window._uniqIdCounter = 0
  }
  // window._uniqIdCounter++;
  return ++window._uniqIdCounter
}
